import { useBaseApi } from "@/hooks/useBaseApi.ts";
import { getUserInfo, getUserLogin } from "@/apis/login.ts";
import { useAccountStore } from "@/store/modules/account.ts";
import router from "@/router";

// 从地址栏获取参数
export function getUrlParams (url?: string) {
  const params: Record<string, any> = {};
  const queryString = url ? url.split('?')[1] : window.location.search.slice(1);
  const paramPairs = queryString.split('&');

  for (let i = 0; i < paramPairs.length; i++) {
    const pair = paramPairs[i].split('=');
    const key = decodeURIComponent(pair[0]);
    params[key] = pair.length > 1 ? decodeURIComponent(pair[1]) : null;
  }
  return params;
}

// 校验登录
export const checkUserStatus = async (errorCallback?: (err)=> void) => {
  const accountStore = useAccountStore()
  const { res, error, doFetch } = useBaseApi(getUserLogin, null, () => {
    console.log('')
  })
  const userInfo = useBaseApi(getUserInfo, null, () => {
    console.log('')
  })
  await doFetch()
  await userInfo.doFetch()


  if (userInfo.res.value) {
    accountStore.setUserInfo(userInfo.res.value)
  }

  if (error.value) {
    errorCallback && errorCallback(error.value)
    return
  }

  if (!res.value) {
    accountStore.setAccount('', accountStore.getTargetUrl())

    // 如果当前路径是登录页面，不要进行重定向，让用户正常访问登录页面
    if (location.pathname === '/login') {
      return
    }

    if (location.pathname === '/rule') {
      router.push({ name: 'rule' })
    } else if (location.pathname === '/mfa') {
      router.push({
        path: '/mfa',
        query: {
          ...getUrlParams(location.search),
        }
      })
    } else if (location.pathname !== '/login') {
      router.push({ name: 'Home' })
    }
  } else if (res.value && (location.pathname === '/login' || location.pathname === '/')) {
    router.replace({ name: 'Welcome' })
  }
}
